/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { PdfHeader } from './pdf-header';
import { NameValue } from '../tool/name-value';

export class PdfUtils {
  static getMinHeight(doc: any, text: string, width: number) {
    const dimen = doc.getTextDimensions(text);
    if (dimen.w > width) {
      return Math.ceil(dimen.w / width) * dimen.h + 11;
    } else {
      return dimen.h;
    }
  }

  static buildMultilineText(doc: any, text: string, width: number): string[] {
    void width;
    const array = text.split(' ');
    return array;
  }

  static truncate(doc: any, text: string, width: number) {
    let textWidth = doc.getTextDimensions(text).w;
    if (textWidth > width) {
      let newText = text;
      while (textWidth > width) {
        newText = newText.slice(0, newText.length - 4) + '...';
        textWidth = doc.getTextDimensions(newText).w;
      }
      return newText;
    } else {
      return text;
    }
  }

  /**
   * Generate PDF header with title, date, author, page and logo
   */
  static generatePageHeader(doc, header: PdfHeader, page: number) {
    if (header.logo) {
      const size = doc.internal.getFontSize();
      // Draw header rect
      doc.setDrawColor(47, 55, 58);
      doc.setTextColor(47, 55, 58);
      doc.rect(30, 30, 142.5, 60); // Rect logo
      doc.setFontSize(9);
      doc.setFont('roboto', 'bold');
      if (header.id) {
        doc.rect(172.5, 30, 50, 30); // Rect Id
        doc.text(178.5, 47, header.id.toUpperCase()); // ID
        doc.rect(222.5, 30, doc.internal.pageSize.getWidth() - 252.5, 30); // Rect Title
        doc.text(228.5, 47, header.title); // Title
      } else {
        doc.rect(172.5, 30, doc.internal.pageSize.getWidth() - 202.5, 30); // Rect Title
        doc.text(189.5, 50, header.title); // Title
      }
      doc.rect(172.5, 60, doc.internal.pageSize.getWidth() - 202.5, 30); // Rect author
      doc.rect(doc.internal.pageSize.getWidth() - 130, 30, 100, 30); // Rect page
      doc.rect(doc.internal.pageSize.getWidth() - 130, 60, 100, 30); // Rect date

      doc.addImage(
        header.logo.image,
        header.logo.extension.toUpperCase(),
        50,
        37.5
      );
      doc.text(doc.internal.pageSize.getWidth() - 124, 48, `Page ${page}`); // Page count
      doc.setFont('roboto', 'normal');
      doc.text(doc.internal.pageSize.getWidth() - 124, 78, header.date); // Date
      if (header.subtitle) {
        if (header.subtitle instanceof String) {
          doc.text(178.5, 78, header.subtitle); // Author
        } else if (header.subtitle instanceof NameValue) {
          const dimension = doc.getTextDimensions(header.subtitle.name);
          doc.setFont('roboto', 'bold');
          doc.text(178.5, 78, header.subtitle.name);
          doc.setFont('roboto', 'normal');
          doc.text(178.5 + dimension.w + 4, 78, ': ' + header.subtitle.value);
        }
      }
      doc.setFontSize(size);
    }
  }
  static addPage(doc, header: PdfHeader) {
    doc.addPage();
    PdfUtils.generatePageHeader(doc, header, doc.internal.getNumberOfPages());
  }
}
